<template lang="pug">
  v-expansion-panels.competition-selector-collapsable(v-model="showPanel")
    v-expansion-panel
      v-expansion-panel-header {{ info }}: {{ activeCard.name }}
      v-divider
      v-expansion-panel-content.px-0.py-3.competition-selector-collapsable__content
        template
          v-list-item.px-3(v-for="(competition,key) in competitionListAll"  :key="'competition'+key" @click="link(competition._id, competition.name)"  :class="{'orange lighten-5': activeCard.id == competition._id}")
            v-list-item-icon.py-0.my-0
                v-icon.display-1 mdi-soccer
            v-list-item-content.py-0
              v-list-item-title.d-flex.justify-space-between
                p.subtitle-1.mb-2 {{ competition.name }}
                TooltipSimple
                  p.overline.my-1 {{ competition.country.name }}
                  p.subtitle-2.my-1.green--text(v-if="competition.enabled == true") {{ $t('back.states.'+ competition.enabled) }}
                  p.subtitle-2.my-1.red--text(v-else-if="competition.enabled == false") {{ $t('back.states.'+ competition.enabled) }}

</template>

<script>

  import TooltipSimple from "@/components/tooltips/TooltipSimple";

  export default {
    name: "CompetitionSelectorCollapsable",
    components:{
      TooltipSimple
    },
    props:{
      info: {
        type: String,
        default: ''
      },
      competitionListAll: {
        type: Array,
        default: function(){
          return {}
        }
      },
      competitionid:{
        type: String,
        default: undefined
      }
    },
    data: ()=>({
      activeCard: {
        id: null,
        name: ''
      },
      showPanel: false
    }),
    watch: {
      competitionListAll: function (val){
        const vm = this;
        if(vm.activeCard.name == undefined || vm.activeCard.name == ''){
          const competition = val.filter((competition)=>{
            return competition._id == vm.competitionid
          })
          if(competition.length > 0){
            vm.activeCard.name = competition[0].name
          }
        }
      }
    },
    created(){
      if(this.competitionid){
        this.link(this.competitionid);
      }
    },
    methods:{
      link(id, name){
        this.showPanel = false;
        this.activeCard.id = id;
        this.activeCard.name = name;
        this.$emit('cardClicked', id);
      }
    }
  }
</script>

<style lang="sass">
.competition-selector-collapsable
  &__content > .v-expansion-panel-content__wrap
    padding: 0
</style>